// components/ui/AIButton.jsx
import React, { useState, useEffect } from 'react';
import ChatbotContainer from './ChatbotContainer';

const questions = [
  "오늘 우산 필요해?",
  "지금 바람 많이 불어?",
  "비 언제 멈춰?",
  "기온 얼마나 올라가?",
  "미세먼지 괜찮아?"
];

const AIButton = ({onClick}) => {
  const [index, setIndex] = useState(0);
  const [showChatbot, setShowChatbot] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % questions.length);
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  const handleButtonClick = () => {
    setShowChatbot(true);
    if (onClick) onClick();
  };

  const handleCloseChatbot = () => {
    setShowChatbot(false);
  };

  return (
    <>
      <div 
        className="flex items-center mr-12 space-x-4 mt-[-5px] mb-5 bg-black text-white rounded-full px-4 py-1.5 shadow-md hover:scale-105 transition-transform duration-200 cursor-pointer white-glow"
        style={{ opacity: 1, transition: 'opacity 0.3s ease' }}
        onClick={handleButtonClick}
      >
        <div className="bg-green-500 w-8 h-8 flex items-center justify-center rounded-full font-bold text-black white-glow">
          AI
        </div>
        <span
          key={questions[index]}
          className="text-base font-medium w-60 text-center overflow-hidden"
          style={{ 
            transition: 'opacity 0.3s ease, transform 0.3s ease',
            opacity: 1,
            transform: 'translateY(0)'
          }}
        >
          Q : {questions[index]}
        </span>
      </div>

      {showChatbot && <ChatbotContainer onClose={handleCloseChatbot} />}
    </>
  );
};

export default AIButton;